import { Link } from '@ecomm/framework/Link'
import { Trans, useTranslation } from '@ecomm/i18n'
import type { ReactNode } from 'react'
import { ModalFeatures } from '../ModalFeatures'
import { ModalFooter } from '../ModalFooter'
import { MonitoringPlanModalV2 } from '../MonitoringPlanModalV2'

export function StandardMonitoringBusinessModal({
  children,
  showCTA = false
}: { readonly children: ReactNode; readonly showCTA?: boolean }) {
  const { t } = useTranslation('maps')

  const includedFeatures = [
    t('feature-title.three-year-warranty'),
    t('feature-title.police-dispatch'),
    t('feature-title.fire-dispatch'),
    t('feature-title.ambulance-dispatch'),
    t('feature-title.hd-live-view-business'),
    t('feature-title.unique-pins-10-business'),
    t('feature-title.staff-app-access-business'),
    t('feature-title.dedicated-support-business')
  ] as const

  const excludedFeatures = [
    t('feature-title.multi-cameras-business'),
    t('feature-title.live-agent-outdoor-business'),
    t('feature-title.live-agent-indoor-business'),
    t('feature-title.unlimited-recordings'),
    t('feature-title.video-verification'),
    t('feature-title.hazard-monitoring'),
    t('feature-title.hardware-discount'),
    t('feature-title.anti-theft')
  ] as const

  return (
    <MonitoringPlanModalV2
      buttonLabel={children}
      title={t('plan-name.standard-business')}
      description={t('plan-description.standard-business')}
    >
      <ModalFeatures
        includedFeatures={includedFeatures}
        excludedFeatures={excludedFeatures}
      />

      <ModalFooter
        showCTA={showCTA}
        price={t('microtext.price-per-day', {
          value: t('plan-price-per-day.standard-business')
        })}
        disclaimer={
          <Trans
            components={{
              termsLink: (
                <Link
                  className="text-inherit hover:no-underline"
                  to="/terms-of-service"
                >
                  text
                </Link>
              )
            }}
          >
            {t('feature-disclaimer.three-year-warranty')}
          </Trans>
        }
      />
    </MonitoringPlanModalV2>
  )
}
